import React, { HTMLAttributes } from 'react'
import { useNavigate } from 'react-router'
import { Nav } from 'rsuite'

type Props = {
  id: string,
  link?: string,
  name: string,
  icon: React.FunctionComponent<HTMLAttributes<SVGElement>>,
  active?: boolean,
  disabled?: boolean
}
// No `title` here: RSuite already renders its own tooltip for Nav.Item rows
// while the Sidenav is collapsed, so a native one would stack a second box on
// top of it.
const NavItem = ({ id, link, name, icon: Icon, active, disabled }: Props) => {
  const navigate = useNavigate()

  return (
    <Nav.Item
      eventKey={id}
      className={active ? 'active' : ''}
      onClick={() => link && navigate(link)}
      icon={<Icon className="rs-sidenav-item-icon rs-icon" />}
      disabled={disabled}
    >
      <span className="sidenav-item__text">{name}</span>
    </Nav.Item>
  )
}
export default NavItem
